import { Color } from '@/types/models';

const HEX_RADIX = 16;
const ALPHA_HEX_LENGTH = 2;
const RGB_HEX_START = 0;
const RGB_HEX_END = 7; // '#RRGGBB'

/**
 * Replaces the alpha channel of a #RRGGBBAA color with the given value (0-255).
 */
export const setHexAlpha = (color: Color, alpha: number): Color => {
  const alphaHex = alpha.toString(HEX_RADIX).padStart(ALPHA_HEX_LENGTH, '0').toUpperCase();
  return `${color.slice(RGB_HEX_START, RGB_HEX_END)}${alphaHex}`;
};
